module.exports = __webpack_public_path__ + "img/github.85a0abaa.svg";